import React, { useEffect, useState } from "react";
import PageContainer from "../../components/PageContainer";
import MainContent from "../../components/MainContent";
import BillingMetricCards from "../../components/SchoolFees/BillingCenter/BillingMetricCards";
import BillingStructure from "../../components/SchoolFees/BillingCenter/BillingStructure";
import PaymentTrends from "../../components/SchoolFees/BillingCenter/PaymentTrends";
import BillingOverview from "../../components/SchoolFees/BillingCenter/BillingOverview";
import BillingActions from "../../components/SchoolFees/BillingActions";
import { useSchoolTransactions } from "../../DataStore/FeesTransactionContext";
import PageTitle from "../../components/Common/PageTitle/PageTitle";
import { useSchool } from "../../DataStore/SchoolContext";
import { useTheme } from "../../DataStore/ThemeContext";
import ActionDropdownItem from "../../components/Common/PageTitle/ActionDropdownItem";
import ConfirmationDialog from "../../components/Common/ConfirmationDialog";
import ajaxSchool from "../../util/remote/ajaxSchool";
import Notification from "../../components/Common/Notification";
import AlertNotification from "../../components/Common/AlertNotification";
import ManageStructureModal from "../../components/SchoolFees/BillingCenter/ManageStructureModal";
import { useCurrency } from "../../util/SystemVariables";
import { useNavigate } from "react-router-dom";


const BillingCenterPage = () => {
 
  const {
    getCollectionOverview, 
    collectionOverview, 
    discountedSum,
    paidSum, 
    getDiscountedSum, 
    getBillingSummary,
    billingSummary
} = useSchoolTransactions();

const {getFeesStructures, feesStructures, showDeleteFeesGroup, setShowDeleteFeesGroup, getFeesVotes} = useSchool();
const {openSettings, closeSettings, setNotify} = useTheme();
const [showUnassignFeesGroups, setShowUnassignFeesGroups] = useState(false);
const [showManageStructureModal, setShowManageStructureModal] = useState(false);
const [selectedStructure, setSelectedStructure] = useState(null);
const currency = useCurrency();
const navigate = useNavigate();



  useEffect(()=>{
    getCollectionOverview();
    getDiscountedSum();
    getBillingSummary();
    getFeesStructures();
    getFeesVotes();
  }, [])

  const refresh = async()=>{
    await getCollectionOverview(true);
    await getDiscountedSum(true);
    await getBillingSummary(true);
    await getFeesStructures(true);
    await getFeesVotes(true);
  }

  const handleNewBatch = ()=>{
    navigate('/school-fees-batch')
  }

  const handleNewGroup = ()=>{
    openSettings("New Fees Group", "NewFeesGroup", null, "Save Fees Group");
  }
  const handleManageFeesVotes = ()=>{
    navigate("/school-fees-votes");
  }

  const handleConfigureGroup = ()=>{
     if(!selectedStructure){
      setNotify(<AlertNotification type="danger" message="No fees structure selected. Please select a structure then try again." closable={false} iconClass="fa fa-info-circle"/>);
      return;
    }
    openSettings("Configure Fees Group", "FeesGroupConfig", selectedStructure, "Save Configuration");
  }

  const handleAssignVote = ()=>{
    if(!selectedStructure){
      setNotify(<AlertNotification type="danger" message="No fees structure selected. Please select a structure then try again." closable={false} iconClass="fa fa-info-circle"/>);
      return;
    }
    openSettings("Assign Vote to Group", "AssignVote", selectedStructure, "Assign Vote");
  }

  const handleManageStructure = (feesGroup)=>{
    openSettings("Configure Fees Group", "FeesGroupConfig", feesGroup, "Save Configuration");
  }

  const handleEditGroup = ()=>{
    if(!selectedStructure){
      setNotify(<AlertNotification type="danger" message="No fees structure selected. Please select a structure then try again." closable={false} iconClass="fa fa-info-circle"/>);
      return;
    }
    openSettings("Edit Fees Group", "EditFeesGroup", selectedStructure.group_info, "Save Changes");
  }

  const handleDeleteGroup = ()=>{
    if(!selectedStructure){
      setNotify(<AlertNotification type="danger" message="No fees structure selected. Please select a structure then try again." closable={false} iconClass="fa fa-info-circle"/>);
      return;
    }
    setShowDeleteFeesGroup(true);
  }

  const confirmDeleteGroup = async()=>{
    closeSettings();
    setNotify(<AlertNotification message="Deleting fees group..." loader={true} />);
    const server_response = await ajaxSchool.deleteFeesGroup(selectedStructure.group_info.id);
    if(server_response.status === "OK"){
      setNotify(<Notification type="success" message={server_response.message} closable={false} />);
      setShowDeleteFeesGroup(false);
      getFeesStructures(true);
    }else{
      setNotify(<Notification type="danger" message={server_response.message} closable={false} />);
    }
  }

  

  const confirmAssignFeesGroups = async()=>{
    setShowUnassignFeesGroups(false);
    setNotify(<AlertNotification message="Unassigning fees groups..." loader={true} />);
    const server_response = await ajaxSchool.unassignFeesGroups();
    if(server_response.status === "OK"){
      setNotify(<Notification type="success" message={server_response.message} closable={false} />);
      getFeesStructures(true);
    }else{
      setNotify(<Notification type="danger" message={server_response.message} closable={false} />);
    }
  }

  const handleSyncFeesGroups = async()=>{
    setNotify(<AlertNotification message="Syncing fees groups...finding unassigned students..." loader={true} />);
    const server_response = await ajaxSchool.syncFeesGroups();
    if(server_response.status === "OK"){
      setNotify(<Notification type="success" message={server_response.message} closable={false} />);
      getFeesStructures(true);
    }else{
      setNotify(<Notification type="danger" message={server_response.message} closable={false} />);
    }
  }

  const PageActions = ()=>(<>
      <ActionDropdownItem iconClass="fas fa-calendar-alt" label="Billing Batches" onClick={handleNewBatch}/>
      <ActionDropdownItem iconClass="fa fa-tag" label="Manage Fees Votes" onClick={handleManageFeesVotes}/>
      <ActionDropdownItem iconClass="fa fa-users" label="Create Fees Group" onClick={handleNewGroup}/>
      <ActionDropdownItem iconClass="fa fa-plus-circle" label="Assign Vote to Group" onClick={handleAssignVote} disabled={selectedStructure ? false : true}/>
      <ActionDropdownItem iconClass="fa fa-arrows-rotate" label="Sync Fees Groups" onClick={handleSyncFeesGroups}/>
      <ActionDropdownItem iconClass="fa fa-wrench" label="Configure Fees Group" onClick={handleConfigureGroup} disabled={selectedStructure ? false : true}/>
      <ActionDropdownItem iconClass="fa fa-refresh" label="Refresh" onClick={refresh} disabled={selectedStructure ? false : true}/>
      <ActionDropdownItem iconClass="fa fa-pencil" label="Edit Fees Group" onClick={handleEditGroup} disabled={selectedStructure ? false : true}/>
      <ActionDropdownItem iconClass="fa fa-trash-can" label="Delete Fees Group" onClick={handleDeleteGroup} className="text-danger"/>

    </>)

    
  return (<>
    <PageContainer>
      <MainContent>
        <PageTitle
          title="Billing Center"
          description="Manage fees groups, votes and billing structures. View payment trends and billing overview."
          iconClass="fa fa-handshake"
          PageActions={PageActions}
          sticky={true}
        />
        <div className="row">
          <div className="col-md-12">
            <BillingMetricCards currency={currency} />
          </div>
         
        </div>
        <div className="row">
            <div className="col-md-4">
                {collectionOverview && <PaymentTrends
                     collectionData={collectionOverview}
                     discount={discountedSum}
                     paidSum={paidSum}
                     currency={currency}
                     />}
                <BillingOverview summaryData={billingSummary}/>
            </div>
            <div className="col-md-8">
                    <BillingActions
                        newGroup = {handleNewGroup}
                        unassignGroups = {()=>setShowUnassignFeesGroups(true)}
                        syncGroups = {handleSyncFeesGroups}
                    />
                    <BillingStructure feesStructure={feesStructures} handleManage={handleManageStructure} onSelect={setSelectedStructure}/>               

            </div>
        </div>
      

      </MainContent>
    </PageContainer>
      <ConfirmationDialog
        title="Delete Fees Group"
        alertDescription="Are you sure you want to delete this fees group?"
        notes="If the fees group is assigned to any student, the students will be unassigned from the group."
        show={showDeleteFeesGroup}
        handleClose={()=>setShowDeleteFeesGroup(false)}
        handleConfirm={()=>confirmDeleteGroup()}
        buttonLabel="Confirm Delete"
        value={selectedStructure?.group_info?.group_name}
        />


      <ConfirmationDialog
        title="Unassign Fees Groups"
        alertDescription="Are you sure you want to unassign all fees groups from current students?"
        notes="You can automatically re-assign fees groups to students later by syncing the students."
        show={showUnassignFeesGroups}
        handleClose={()=>setShowUnassignFeesGroups(false)}
        handleConfirm={()=>confirmAssignFeesGroups()}
        buttonLabel="Unassign Groups"
        />
        <ManageStructureModal
          show={showManageStructureModal}
          onClose={() => setShowManageStructureModal(false)}
          structure={selectedStructure}
        />
    </>
  );
};

export default BillingCenterPage;